export const SET_HELP_DATA = "SET_HELP_DATA";
export const ADD_NEW_HELP = "ADD_NEW_HELP";
export const ADD_NEW_HELP_DISMISS = "ADD_NEW_HELP_DISMISS";
export const ADD_NEW_HELP_PREVIEW = "ADD_NEW_HELP_PREVIEW";
export const EDIT_HELP_PREVIEW = "EDIT_HELP_PREVIEW";
export const EDIT_HELP_DISMISS = "EDIT_HELP_DISMISS";
export const EDIT_HELP = "EDIT_HELP";
export const DELETE_HELP_PREVIEW = "DELETE_HELP_PREVIEW";
export const DELETE_HELP_DISMISS = "DELETE_HELP_DISMISS";
export const DELETE_HELP = "DELETE_HELP";
export const HELP_FETCHING_INIT = "HELP_FETCHING_INIT";
export const HELP_FETCHING_COMPLETE = "HELP_FETCHING_COMPLETE";
export const SET_HELP_PAGE = "SET_HELP_PAGE";

const initialState = {
  showClassHelp: false,
  helpQus: "",
  helpAns: "",
  helpDetailStatus: false,
  allHlpData: [],
  helpDataAll: [],
  searchValue: "",

  /* For Dashboard page */
  new_help_popup: false,
  help_question: "",
  help_answer: "",
  edit_help: null,
  ed_help_question: "",
  ed_help_answer: "",
  eU_error: "",
  delete_help: null,

  helplist_refetch: false,
  helplist_refetch_force: false,
  pageSearch: "",
  page: 1,
  perpage: 20,
  total_help: 0,
  help_list: [],
  _hlpQsn: "question",
  _hlpAns: "answer",
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_HELP_DATA: {
      return { ...state, ...action.payload };
    }
    case ADD_NEW_HELP: {
      return {
        ...state,
        helplist_refetch: true,
        pageSearch: "",
        add_btn_disable: false,
      };
    }
    case ADD_NEW_HELP_PREVIEW: {
      return {
        ...state,
        new_help_popup: true,
        help_question: "",
        help_answer: "",
      };
    }
    case ADD_NEW_HELP_DISMISS: {
      return {
        ...state,
        new_help_popup: false,
        ...action.payload,
        add_btn_disable: false,
      };
    }
    case EDIT_HELP_PREVIEW: {
      return { ...state, eU_error: "", ...action.payload };
    }
    case EDIT_HELP_DISMISS: {
      return { ...state, edit_help: null };
    }
    case EDIT_HELP: {
      return {
        ...state,
        helplist_refetch: true,
        pageSearch: "",
        edit_btn_disable: false,
      };
    }
    case DELETE_HELP_PREVIEW: {
      return { ...state, delete_help: action.payload };
    }
    case DELETE_HELP_DISMISS: {
      return { ...state, delete_help: null };
    }
    case DELETE_HELP: {
      return {
        ...state,
        helplist_refetch: true,
        pageSearch: "",
        del_btn_disable: false,
      };
    }
    case HELP_FETCHING_INIT: {
      return {
        ...state,
        helplist_refetch: false,
        helplist_refetch_force: false,
      };
    }
    case HELP_FETCHING_COMPLETE: {
      return { ...state, ...action.payload };
    }
    case SET_HELP_PAGE: {
      return { ...state, helplist_refetch: true, page: action.payload };
    }
    default:
      return state;
  }
};
